<template>
  <div>
    <v-data-table
      v-bind="this.$attrs"
      :options.sync="tableOptions"
      loading-text="Đang Tải"
      item-key="id"
      :headers="headers"
      :items="dishes"
      :server-items-length="totalItems"
      :disable-sort="$vuetify.breakpoint.smAndDown"
      :footer-props="footerTable"
      :loading="loading"
      no-data-text="Không có món ăn"
    >
      <template v-slot:[`item.type`]="{ item }">
        <span>{{ item.type | dishType }}</span>
      </template>
      <template v-slot:[`item.image`]="{ item }">
        <div class="image-wrapper my-4">
          <v-img :src="$_get(item, 'image.url')" alt="" contain />
        </div>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div>
          <v-btn @click="onEdit(item)" icon><v-icon left>mdi-pencil</v-icon></v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item :disabled="!$auth.policies['update-attendance']">
                <v-list-item-title style="cursor: pointer" @click="onRemove(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-data-table>
    <DishEditDialog :state="editDialog" :dishData="selectedItem" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

const originHeaders = [
  {
    text: 'Món ăn',
    value: 'name',
    align: 'left',
    sortable: false
  },
  {
    text: 'Nhóm món',
    value: 'type',
    align: 'left',
    sortable: false
  },
  {
    text: 'Hình ảnh',
    value: 'image',
    align: 'left',
    sortable: false
  },
  {
    text: 'Thao tác',
    value: 'actions',
    align: 'left',
    sortable: false
  }
]

export default {
  components: {
    DishEditDialog: () => import('@/modules/dish/DishEditDialog.vue')
  },
  props: {},
  data() {
    return {
      headers: originHeaders,
      tableOptions: {},
      editDialog: false,
      selectedItem: null
    }
  },
  async created() {
    await this.refresh()
  },
  methods: {
    ...mapActions('Dishes', ['requestPageSettings', 'searchDishList', 'removeDish']),
    async refresh(query) {
      query = query || {}
      this.searchDishList(query)
    },
    onEdit(item) {
      this.editDialog = !this.editDialog
      this.selectedItem = item
    },
    onRemove(item) {
      this.$dialog.confirm({
        title: 'Thông báo xác nhận',
        text: 'Bạn có chắc muốn xóa món ăn này? Bạn không thể hoàn tác hành động.',
        okText: 'OK',
        cancelText: 'Hủy',
        done: async () => {
          this.$loading.active = true
          try {
            await this.removeDish(item.id)
            this.$alert.deleteSuccess()
          } catch (error) {
            this.$alert.deleteError(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  },
  computed: {
    ...mapState('Dishes', ['dishes', 'totalItems', 'pageText', 'loading']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.image-wrapper {
  width: 55px;
  min-width: 55px;
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 4px;
  }
}
</style>
